"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductFruitsUtil = exports.ProductFruits = void 0;
var productFruits_1 = require("./productFruits");
Object.defineProperty(exports, "ProductFruits", { enumerable: true, get: function () { return __importDefault(productFruits_1).default; } });
var productFruitsUtil_1 = require("./productFruitsUtil");
Object.defineProperty(exports, "ProductFruitsUtil", { enumerable: true, get: function () { return __importDefault(productFruitsUtil_1).default; } });
